module.exports = __webpack_public_path__ + "img/Wasserrettungstrupp.8092ae04.svg";